import { RETURN_TO_PARAM, safeReturnPath } from '@beatq/shared';

const AUTH_PATHS = ['/corporate-sign-in', '/corporate-sign-up', '/accept-invite'];

function fromLocationState(state: unknown): string | null {
  if (typeof state === 'string') return state;
  if (state && typeof state === 'object' && 'from' in state) {
    const from = (state as { from?: unknown }).from;
    return typeof from === 'string' ? from : null;
  }
  return null;
}

function isAuthPath(path: string): boolean {
  const pathname = path.split('?')[0] ?? path;
  return AUTH_PATHS.some((prefix) => pathname === prefix);
}

/** Preserve approval (019) / invoice (023) deep links through corporate sign-in. */
export function resolvePostLoginPath(
  search: string,
  locationState: unknown,
  fallback = '/',
): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const fromQuery = params.get(RETURN_TO_PARAM);
  const fromState = fromLocationState(locationState);
  const safe = safeReturnPath(fromQuery || fromState, fallback);
  if (isAuthPath(safe)) return fallback;
  return safe;
}
